"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RetirementIncomeGapPageFour;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _RetirementIncomeGapFormControls = require("./RetirementIncomeGapFormControls");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function RetirementIncomeGapPageFour(_ref) {
  var {
    setHasRetirementIncomeGap
  } = _ref;
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();

  // Doing a similar useEffect here as we do on page 5, so that the hasRetirementIncomeGap state is already set
  // If this is not done, you can see the a momentary flash between the two sidebar svgs on page 5
  (0, _react.useEffect)(() => {
    document.getElementById(_RetirementIncomeGapWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else*/
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);
  (0, _react.useEffect)(() => {
    var willNeedValue = sumFutureExpenses();
    var willHaveValue = sumRetirementIncome();
    var retireIncomeGapValue = willNeedValue - willHaveValue;
    if (retireIncomeGapValue > 0) {
      setHasRetirementIncomeGap(true);
    } else {
      setHasRetirementIncomeGap(false);
    }
  }, [values.socialSecurityBenefit, values.pension, values.otherIncome]);
  function sumFutureExpenses() {
    return 0 + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_housingAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_healthcareAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_transportationAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_groceriesAndDiningOutCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_travelAndEntertainmentCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.futureInflated_personalAndMiscellaneousCost));
  }
  function sumRetirementIncome() {
    return 0 + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.socialSecurityBenefit)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.pension)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.otherIncome));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.SocialSecurityBenefit, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.Pension, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    text: _RetirementIncomeGapWizardCalc.popoverConfig.otherIncome,
    fieldName: 'otherIncomePopover'
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.OtherIncome, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }));
}